import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

export default function OrganizationEmptyState({ label }) {
  return (
    <Card>
      <CardContent>
        <Typography variant="body1">
          No {label} selected.
        </Typography>
      </CardContent>
    </Card>
  );
}
